import { proxy } from 'valtio';

import { SpotlightScreen } from '@canvas/model/onboarding';

const SpotlightScreenValues: SpotlightScreen[] = Object.values(SpotlightScreen);

function isSpotlightScreen(screen: string): screen is SpotlightScreen {
  const values: string[] = SpotlightScreenValues;
  return values.includes(screen);
}

interface OnboardingState {
  active: boolean;
  screen: SpotlightScreen;
  /* Controls the animation CSS for the
   * toolbar and side nav. Allowing animation while the spotlight is running
   * causes a visual bug so we want to disallow it until the spotlight is complete.
   */
  allowAnimation: boolean;
}

export const currentOnboardingState = proxy<OnboardingState>({
  active: false,
  screen: SpotlightScreen.TEMPLATES,
  allowAnimation: true,
});

export const onSpotlightStart = (initialSpotlightScreen?: string) => {
  if (initialSpotlightScreen && isSpotlightScreen(initialSpotlightScreen)) {
    currentOnboardingState.screen = initialSpotlightScreen;
  }
  currentOnboardingState.active = true;
  currentOnboardingState.allowAnimation = false;
};

export const onSpotlightEnd = () => {
  /* We're not setting allowAnimation to true here since resetting it would
   * cause the side nav and toolbar to re-animate when onboarding is dismissed
   * even though the page has already loaded. Screen is also not being reset
   * because we want to pass the value of the screen the spotlight was closed on
   * back to Confluence for analytics purposes.
   *
   * They will be reset when the user navigates to a different whiteboard and on
   * SPA transitions.
   */
  currentOnboardingState.active = false;
};

export const triggerSpotlight = (screenName: SpotlightScreen) => {
  currentOnboardingState.screen = screenName;
};
